export { AboutUsDetailPage } from './view/about-us-detail-page';
